import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import mixpanel from '../../utilities/mixpanel'

import useAuth from '../../utilities/hooks/useAuth'

function LogoutFeature() {
  const { signOutUser } = useAuth()
  const history = useHistory()

  useEffect(() => {
    mixpanel.track('Signed Out')
    signOutUser()
    history.replace('/')
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export default LogoutFeature
